var parent = require('../../es/object/get-own-property-descriptor');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/get-own-property-descriptor.js
// module id = 554
// module chunks = 0 1